import http from '@/http-common'
import Tab from '@/components/TabSpr.vue'
import FederationPage from "@/views/FederationsListPage.vue"
import TotalSprEditModal from "@/views/totalspr/TotalSprEditModal.vue"
import InputGroupForm from '@/components/InputGroupForm.vue'

export default {
  name: 'discipline',
  components: {Tab, TotalSprEditModal, FederationPage, InputGroupForm},
  props: {
    isCalled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isBusy: false,
      reloadTab: true,
      captionSpr: {
        name: 'Дисциплины',
        nameR: 'Дисциплины'
      },
      selectedItem: {
        name: '',
        sportKindId: null
      },
      items: [],
      columns: [],
      urls: null,
      typeList: [
        {
          value: 0,
          text: 'Дисциплина',
          urls: {
            list: '/discipline/list',
            save: '/discipline',
            delete: '/discipline',
          },
          columns: [
            {key: 'code', label: 'Код', width: '100px'},
            {key: 'name', label: 'Наименование', sortable: true, sorted: true, width: '400px'},
            {key: 'federation', label: 'Федерация', sortable: true, sorted: true},
            {key: 'edit_field', label: '', firstClass: 'width10', sortable: false}
          ],
          caption: {
            name: 'Дисциплины',
            nameR: 'Дисциплины'
          }
        },
        {
          value: 1,
          text: 'Этап спортивной подготовки',
          urls: {
            list: '/stage_training/list',
            save: '/stage_training/save',
            delete: '/stage_training/delete',
          },
          columns: [
            {key: 'name', label: 'Наименование', sortable: true, sorted: true, width: '400px'},
            {key: 'description', label: 'Описание', sortable: true, sorted: true},
            {key: 'edit_field', label: '', firstClass: 'width10', sortable: false}
          ],
          caption: {
            name: 'Этап спортивной подготовки',
            nameR: 'Этапа спортивной подготовки'
          }
        },
        {
          value: 2,
          text: 'Должности в команде',
          urls: {
            list: '/people_post/list',
            save: '/people_post/save',
            delete: '/people_post/delete',
          },
          columns: [
            {key: 'name', label: 'Наименование', sortable: true, sorted: true, width: '400px'},
            {key: 'description', label: 'Описание', sortable: true, sorted: true},
            {key: 'edit_field', label: '', firstClass: 'width10', sortable: false}
          ],
          caption: {
            name: 'Должность в команде',
            nameR: 'Должности в команде'
          }
        },
        {
          value: 3,
          text: 'Места проживания',
          urls: {
            list: '/locality/list',
            save: '/locality/save',
            delete: '/locality/delete',
          },
          columns: [
            {key: 'name', label: 'Наименование', sortable: true, sorted: true, width: '400px'},
            {key: 'description', label: 'Описание', sortable: true, sorted: true},
            {key: 'localityTypeName', label: 'Тип объекта', sortable: true, sorted: true},
            {key: 'edit_field', label: '', firstClass: 'width10', sortable: false}
          ],
          caption: {
            name: 'Место проживания',
            nameR: 'Места проживания'
          }
        },
        {
          value: 4,
          text: 'Команды',
          urls: {
            list: '/team/list',
            save: '/team/save',
            delete: '/team/delete',
          },
          columns: [
            {key: 'name', label: 'Наименование', sortable: true, sorted: true, width: '400px'},
            {key: 'description', label: 'Описание', sortable: true, sorted: true},
            {key: 'edit_field', label: '', firstClass: 'width10', sortable: false}
          ],
          caption: {
            name: 'Команда',
            nameR: 'Команды'
          }
        },
        {
          value: 5,
          text: 'Лучшие события',
          urls: {
            list: '/best_event/list',
            save: '/best_event/save',
            delete: '/best_event/delete',
          },
          columns: [
            {key: 'name', label: 'Наименование', sortable: true, sorted: true, width: '400px'},
            {key: 'description', label: 'Описание', sortable: true, sorted: true},
            {key: 'edit_field', label: '', firstClass: 'width10', sortable: false}
          ],
          caption: {
            name: 'Лучшее событие',
            nameR: 'Лучшего события'
          }
        },
      ],
      selectedType: 0,
      modalEditOpened: false,
      validValue: {
        name: true,
        sportKind: true,
        form: true
      },
      federationList: [],
      localityTypeList: [],
      visibleFields: {
        name: true,
        code: true,
        description: true,
        federation: false
      }
    }
  },
  created() {
    this.loadFederations()
    this.loadLocalityTypes()
    this.changeType(0)
  },
  computed: {
    computedFields() {
      return this.columns.map(field => (
          field.width ? {
            ...field,
            thStyle: {width: field.width, minWidth: field.width},
            tdAttr: {style: `max-width: ${field.width}; overflow: hidden;`}
          } : {...field}
      ))
    }
  },
  methods: {
    loadItems() {
      var vm = this;
      this.isBusy = true;
      http.get(this.typeList[this.selectedType].urls.list)
      .then((response) => {
        vm.items = response.data;
      })
      .catch((error) => console.log(error.message))
      .finally(() => vm.isBusy = false);
    },
    loadFederations() {
      let vm = this;
      vm.federationList = []
      http.get('/federation/list')
      .then((response) => {
        vm.federationList = response.data;
      })
      .catch((error) => console.log(error.message));
    },
    loadLocalityTypes() {
      let vm = this;
      vm.localityTypeList = []
      http.get('/locality/types')
      .then((response) => {
        vm.localityTypeList = response.data;
      })
      .catch((error) => console.log(error.message));
    },
    rowSelected(items) {
      for (var key in items[0]) {
        this.selectedItem[key] = items[0][key];
      }
      this.$emit('input', this.selectedItem)
    },
    showEditDialog() {
      if (this.isCalled && this.selectedItem.id > 0) {
        this.rowSelected([this.selectedItem]);
        this.$emit('selectItem')
      } else {
        this.$refs.editModal.showModal(this.selectedItem)
      }
    },
    saveItem(item) {
      this.modalEditOpened = false;
      this.$refs.DisciplineTab.save(item);
    },
    changeType(val) {
      let vm = this;
      this.columns = this.typeList[val].columns;
      this.urls = this.typeList[val].urls;
      for (let key in this.visibleFields) {
        this.visibleFields[key] = false
      }
      this.columns.forEach(function (x) {
        vm.visibleFields[x.key] = true;
      })
      this.loadItems();
    }
  }
}
